import type { QuoteRecord } from '../../domain/quote'

export const quotesFixtures: QuoteRecord[] = [
  {
    id: 'f1ca8100-0000-4000-8000-000000000001',
    number: 'SOU-2026-001',
    status: 'DRAFT',
    subtotalCents: 184500,
    taxTotalCents: 27629,
    totalCents: 212129,
    version: 1,
    validUntil: '2026-08-31',
    notes: 'Déneigement résidentiel — validation finale requise.',
    leadId: 'f1ca8100-0000-4000-8000-000000000101',
    party: { kind: 'LEAD', displayName: 'Marie Tremblay', reference: 'LEAD-2026-014' },
    createdAt: '2026-08-01T13:00:00Z',
    updatedAt: '2026-08-08T14:30:00Z',
  },
  {
    id: 'f1ca8100-0000-4000-8000-000000000002',
    number: 'SOU-2026-002',
    status: 'SENT',
    subtotalCents: 425000,
    taxTotalCents: 63644,
    totalCents: 488644,
    version: 1,
    validUntil: '2026-08-25',
    clientId: 'f1ca8100-0000-4000-8000-000000000102',
    party: { kind: 'CLIENT', displayName: 'Immeubles Laurentides', reference: 'CLI-000418' },
    createdAt: '2026-08-02T15:00:00Z',
    updatedAt: '2026-08-07T18:20:00Z',
  },
  {
    id: 'f1ca8100-0000-4000-8000-000000000003',
    number: 'SOU-2026-003',
    status: 'ACCEPTED',
    subtotalCents: 269900,
    taxTotalCents: 40418,
    totalCents: 310318,
    version: 1,
    validUntil: '2026-08-20',
    clientId: 'f1ca8100-0000-4000-8000-000000000103',
    party: { kind: 'CLIENT', displayName: 'Jean Beaulieu', reference: 'CLI-000421' },
    createdAt: '2026-07-28T11:00:00Z',
    updatedAt: '2026-08-06T09:15:00Z',
  },
]
